import { useState } from 'react';

import { useAuth } from '../auth/auth-context';
import { Card, ErrorAlert, Field, Spinner } from '../components/ui';

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<unknown>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (event: React.FormEvent) => {
    event.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
    } catch (caught) {
      setError(caught);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      <div className="login-card">
        <Card>
          <div className="card-body">
            <div className="login-title">
              <span
                style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--accent)' }}
              />
              MikroManager
            </div>
            <p className="muted" style={{ marginTop: 0, marginBottom: 20 }}>
              Administración de HotSpot MikroTik
            </p>

            <ErrorAlert error={error} />

            <form onSubmit={submit}>
              <Field label="Email">
                <input
                  type="email"
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  autoComplete="username"
                  required
                  autoFocus
                />
              </Field>

              <Field label="Contraseña">
                <input
                  type="password"
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  autoComplete="current-password"
                  required
                />
              </Field>

              <button type="submit" className="primary" style={{ width: '100%' }} disabled={busy}>
                {busy ? <Spinner label="Entrando…" /> : 'Entrar'}
              </button>
            </form>
          </div>
        </Card>
      </div>
    </div>
  );
}
